export default "__VITE_ASSET__58a15914__"